module.exports = __webpack_public_path__ + "img/widget.e1209650.png";